import {SERVICES} from '@/const/services';

export const TRADING_GAME = {
  CUP: '2acb404e5ef4d29f6247703bbcc576f496666576b5fe706fc24d9f81b19265d7.png',
  CUP_GOLD: 'e577907843473b2ffd89712d6abffe3b7dce7aee5cf3b30ce91791bdeea0901b.jpg',
  CUP_SILVER: '1e1118044b513b3b16e3df9f521b9d09bff1e92d19d2b3f343c9faab395f302b.jpg',
  CUP_COPPER: 'b4be1928b87d325ccf57681c644e166fde9825fbb271b4ddf5c97a2494d98a64.jpg',
  RANK_CUP: '6e0df8e2ae6f2efeda26cc000f1ed581c10a1c8a74c35b7141c31d759b459a0e.png',
  BANNER: 'a28b3a320d703b0f6bb59037802ae067089f49eca584c7c3cefbbd27b07f516b.jpg',
  BANNER_TEXT_EN: '4877e264d219eb8d203ad4390564e92a7a4ae884d67f3d6bf5e715199af37e69.png',
  BANNER_TEXT_ES: '572fb765a441004180ea2bb9b8260f195bce89ae00f1df32012ba493177bb046.png',
  BANNER_TEXT_JA: '5d80a6fcf55f825c66902f598898bad3e186aa112e5a939f808ed0d1d0b03bf8.png',
  BANNER_TEXT_DE: 'f304812b762ab7e46f20bfaeaef263a291709569c5182776c0599bbf224c52f7.png',
  BANNER_TEXT_FR: '3a2da105f27d9303cf611cecc7b5309ae73ea81c1f98449d72f09eabf9e1a27c.png',
  BANNER_TEXT_TR: '401891750404f8af496e7877482de4ab7203e0104699c0fac189eb7c2de56f87.png',
  BANNER_TEXT_RU: '502fc57a0b830324c34d7c64d31a80546b489de24d1108c9e077dd7c0c3e29f7.png',
  STEP_ONE: '89704ecd410a8bcd9e539d281684009945f4f8e84264009211b66f28cc8b12eb.png',
  STEP_TWO: 'a41c36fd4042235d48b8ad1dda501279ad5d5f59c9f963f1ff243c2a2ea26427.png',
  STEP_THREE: 'b59efff3e7940dcc98d853a56b3d782c2f34f1bf370e35f97109c75ca85dd700.png',
  SUCCESS: '0c653ede62f327c9a302ebd7653c0e4f7252eef62f063f922a39a2672fa048a1.png',
  WARING: '1efd8dd37b128e853ad9bde23f485c6fad54689d09a8b45abb86ec0b2cb54ecc.png',
  SHARE: 'baec519fcc92de9aaf667b64342227ee39a905319daf27f46c7692776972d5ea.png',
};
const PREFIX_RECEIVE = `${SERVICES.STATIC_URL}/pubimg/`;

Object.keys(TRADING_GAME).forEach((key) => (TRADING_GAME[key] = [PREFIX_RECEIVE, TRADING_GAME[key]].join('')));
